<template>
  <div>
    <AppLayout title="Clientes">
      <template #actions>
        <button type="button" class="btn btn-primary" @click="show_new">Cadastar Cliente</button>
      </template>

      <div class="table-card">
        <table class="table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Telefone</th>
              <th>Endereço</th>
              <th>Aniversário</th>
              <th>Valor em aberto:</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="cliente in lista_clientes">
              <td>{{ cliente.name }}</td>
              <td>{{ cliente.phone }}</td>
              <td>{{ cliente.andress }}</td>
              <td>{{ cliente.day + ' / ' + cliente.month }}</td>
              <td v-if="cliente.onaccount != 'not'">R$ {{ cliente.onaccount.toFixed(2) }}</td>
              <td v-else><button type="button" @click="show_createAccount(cliente)" class="btn btn-success btn-sm">Criar Conta</button></td>
              <td style="width:50px"><button @click="show_edit(cliente)" type="button" class="btn btn-info btn-sm"><i class="bi bi-pencil-square"></i></button></td>
              <td style="width:50px"><button :disabled="autorizated_delet == 0" @click="show_delet(cliente)" type="button" class="btn btn-danger btn-sm"><i class="bi bi-trash-fill"></i></button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </AppLayout>

    <!-- Modal Produto -->
    <div class="modal fade" id="modal_cliente" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div v-if="edit" >
              <h5 class="modal-title">Editar Cliente</h5>
            </div>
            <div v-else >
              <h5  class="modal-title">Cadastrar Cliente</h5>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form id="form-produto">
              <div class="mb-3">
                <label for="inp_name" class="form-label">Nome:</label>
                <input v-model="cliente_obj.name" type="text" class="form-control" name="inp_name" id="inp_name">
              </div>
              <div class="mb-3">
                <label for="inp_phone" class="form-label">Telefone:</label>
                <input v-model="cliente_obj.phone" type="phone" class="form-control" name="inp_phone" id="inp_phone">
              </div>
              <div class="mb-3">
                <label for="inp_andress" class="form-label">Endereço:</label>
                <input v-model="cliente_obj.andress" type="text" class="form-control" name="inp_andress" id="inp_andress">
              </div>
              <label class="form-label">Aniversário:</label>
              <div class="row">
                <div class="mb-3 col">
                  <label for="date_Day" class="form-label">Dia:</label>
                  <input min="1" max="31" value="" v-model="cliente_obj.day" type="number" class="form-control" name="date_Day" id="date_Day">
                </div>
                <div class="mb-3 col">
                  <label for="date_month" class="form-label">Mês:</label>
                  <input min="1" max="12" value="" v-model="cliente_obj.month" type="number" class="form-control" name="date_month" id="date_month">
                </div>
              </div>
              <div v-show="!edit" class="form-check mb-3">
                <input v-model="cliente_obj.createaccount" class="form-check-input" type="checkbox" id="flexCheckDefault">
                <label class="form-check-label" for="flexCheckDefault">
                  Criar conta para o cliente?
                </label>
              </div>
            </form>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button type="submit" @click="action()" class="btn btn-primary">Salvar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal deletar -->
    <div class="modal fade" id="modal_deletar" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Deletar Produto?</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ cliente_obj.name }}</p>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button type="submit" @click="deleteCustumer" class="btn btn-danger">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal conta -->
    <div class="modal fade" id="modal_conta" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Deseja criar uma conta para o cliente?</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ cliente_obj.name }}</p>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button type="submit" @click="createAccount" class="btn btn-danger">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Feedback -->
    <div class="modal fade" id="modal_feedback" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Sucesso</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ msn_feedback }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </template>
  <script>
  import { onMounted, reactive, ref } from 'vue';
  import AppLayout from "@/components/AppLayout.vue";
  import { Modal } from "bootstrap";
  import { clientes } from "@/models/clientes";

  export default {
    name: 'CostumersView',
    components: {
      AppLayout
    },
    setup(props) {
      const Clientes = clientes()
      const lista_clientes = ref([]);

      var edit = ref(false);
      var msn_feedback = ref('');
      var autorizated_delet = ref(false);

      let modal = '';

      function openModal(elemento) {
        const modalNovoProduto = document.getElementById(elemento);
        modal = new Modal(modalNovoProduto);
        modal.show();
      }

      function closeModal() {
        modal.hide();
      }

      function limparDados() {
        cliente_obj.id = '',
        cliente_obj.name = '',
        cliente_obj.phone = '',
        cliente_obj.andress = '',
        cliente_obj.onacount = '',
        cliente_obj.day = '0'
        cliente_obj.month = '0'
      }

      var cliente_obj = reactive({
        'id' : '',
        'name' : '',
        'phone' : '',
        'andress' : '',
        'day' : '',
        'month' : '',
        'onacount' : '',
        'createaccount' : false
      })

      function setItens(item) {
        cliente_obj.id = item.id
        cliente_obj.name = item.name
        cliente_obj.phone = item.phone
        cliente_obj.andress = item.andress
        cliente_obj.onacount = item.onacount
        cliente_obj.day = item.day
        cliente_obj.month = item.month
      }

      const show_edit = (item) => {
        edit.value = true;
        setItens(item);
        openModal('modal_cliente');
      }

      const show_new = (item) => {
        limparDados();
        edit.value = false;
        openModal('modal_cliente');
      }

      const show_delet = (item) => {
        limparDados();
        edit.value = true;
        setItens(item);
        openModal('modal_deletar');
      }

      const show_createAccount = (item) => {
        limparDados();
        edit.value = true;
        setItens(item);
        openModal('modal_conta');
      }

      const action = () => {
        if (edit.value) {
          updateCustumer();
        } else {
          saveCustumer();
        }
      }

      const createAccount = async () => {
        if (await Clientes.createAccount(cliente_obj.id)) {
          closeModal();
          msn_feedback.value = 'Conta criada com sucesso!';
          openModal('modal_feedback');
          limparDados();
          listCustumers();
        } else {
          console.log('Erro ao criar conta para o cliente');
        }
      }

      const saveCustumer = async () => {
        if (await Clientes.createItem(cliente_obj)) {
          closeModal();
          msn_feedback.value = 'Cliente cadastrado com sucesso!';
          openModal('modal_feedback');
          limparDados();
          listCustumers();
        } else {
          console.log('Erro ao cadastrar novo cliente');
        }
      }

      const updateCustumer = async () => {
        if (await Clientes.updateItem(cliente_obj)) {
          msn_feedback.value = "Cliente atualizado com sucesso!"
          closeModal();
          limparDados();
          openModal('modal_feedback');
          listCustumers();
        } else {
          console.log('Erro ao atualizar cliente');
        }
      }

      const deleteCustumer = async () => {
        if (await Clientes.deleteItem(cliente_obj.id)) {
          closeModal();
          limparDados();
          msn_feedback.value = 'Cliente deletado com sucesso!';
          openModal('modal_feedback');
          listCustumers();
        } else {
          console.log('Erro ao deletar cliente');
        }
      }

      const listCustumers = async () => {
        lista_clientes.value = await Clientes.list()
      }

      onMounted(function () {
        listCustumers();
      });

      return {
        cliente_obj,
        show_edit,
        show_new,
        show_delet,
        show_createAccount,
        action,
        edit,
        autorizated_delet,
        deleteCustumer,
        msn_feedback,
        lista_clientes,
        createAccount
      }
    },
  }
  </script>
